import { useTheme } from '@mui/material/styles'
import Avatar from '@mui/material/Avatar'
// import Box from '@mui/material/Box'
// import Button from '@mui/material/Button'
import Drawer from '@mui/material/Drawer'
// import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
// import Tooltip from '@mui/material/Tooltip'

import { closedMixin } from '@/utils/mui'

export const sidebarWidth = 60

export function Sidebar() {
  const theme = useTheme()

  return (
    <Drawer
      variant="permanent"
      sx={[
        {
          overflowX: 'hidden',
          height: '100vh',
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            borderRight: 'none',
            overflowX: 'hidden',
            ...closedMixin(sidebarWidth)(theme),
          },
          ...closedMixin(sidebarWidth)(theme),
        },
      ]}
      PaperProps={{
        elevation: 2,
      }}
    >
      <Stack sx={{ height: '100%' }} spacing={2}>
        <Stack alignItems="center" justifyContent="center" sx={{ height: '80px', p: '16px' }}>
          <Avatar alt="logo" src="/favicon.ico" sx={{ width: 30, height: 30 }} />
        </Stack>
        {/* <Box ref={menuItemsBoxWrapperRef} sx={{ flex: 1, p: '0 10px', overflowX: 'hidden', overflowY: 'auto' }}>
          <Stack ref={menuItemsStackWrapperRef} justifyContent="center" spacing={menuItemSpacing}>
            {menuItems.map((menuItem) => {
              const isMenuItemActive = menuItem.isPathBase ? menuItem.link === pathname : pathname.startsWith(menuItem.link)
              const Icon = menuItem.icon

              const button = (
                <Button
                  className={isMenuItemActive ? 'active' : ''}
                  color="primary"
                  component={Link}
                  to={menuItem.link}
                  fullWidth
                  startIcon={Icon ? <Icon htmlColor={isMenuItemActive ? '#28ACB0' : undefined} sx={{ fontSize: '24px !important' }} /> : undefined}
                  sx={[
                    {
                      color: '#636363',
                      fontFamily: "'Dongle', sans-serif",
                      fontSize: '24px',
                      fontWeight: 400,
                      letterSpacing: '0.025em',
                      lineHeight: '18px',
                      textTransform: 'capitalize',
                      justifyContent: 'start',
                      minWidth: 'unset',
                      pl: '4px',
                      pr: '4px',
                      '& .MuiButton-startIcon': {
                        width: '32px',
                        height: '32px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: 0,
                      },
                    },
                  ]}
                >
                  <Box component="span" sx={{ position: 'absolute', left: '50px', transform: 'translateY(2px)' }}>
                    {menuItem.label}
                  </Box>
                </Button>
              )

              return expanded ? (
                <Box key={menuItem.name}>{button}</Box>
              ) : (
                <Tooltip key={menuItem.name} arrow title={menuItem.label} placement="right">
                  {button}
                </Tooltip>
              )
            })}
          </Stack>
        </Box> */}
      </Stack>
    </Drawer>
  )
}

export default Sidebar
